import { watch, WatchSource } from 'vue';

export function watchUntil<T>(
  source: WatchSource<T>,
  cb: (done: () => void, newVal: T, oldVal?: T) => void,
  options: {
    existingTimeout?: NodeJS.Timeout;
    timeoutSeconds?: number;
    onTimeout?: () => void;
  } = {}
) {
  options.timeoutSeconds = options.timeoutSeconds || 5;
  clearTimeout(options.existingTimeout);
  const watcher = watch(source, (newVal, oldVal) => {
    cb(
      () => {
        clearTimeout(options.existingTimeout);
        watcher.stop();
      },
      newVal,
      oldVal
    );
  });
  options.existingTimeout = setTimeout(() => {
    watcher.stop();
    options.onTimeout?.();
  }, options.timeoutSeconds * 1000);
}
